import { Injectable } from '@angular/core';
import { SoftwareArtifact } from '@nimmsta/ng-commons-lib/models';
import { WorkflowDataService } from '@nimmsta/ng-commons-lib/data-access';
import dayjs from 'dayjs';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SoftwareArtifactService extends WorkflowDataService<SoftwareArtifact> {
  public useSoftwareId(softwareId: string) {
    this.apiEndpoint = `/software/${softwareId}/artifacts`;
  }

  override loadedDataTransform(data: SoftwareArtifact): SoftwareArtifact {
    const artifact = super.loadedDataTransform(data);
    if (artifact.releaseDate) {
      artifact.releaseDate = dayjs(data.releaseDate);
    }
    if (artifact.firmwareBundles?.length) {
      artifact.firmwareBundle = artifact.firmwareBundles[0];
    } else if (artifact.firmwareBundle) {
      artifact.firmwareBundles = [artifact.firmwareBundle];
    }
    return artifact;
  }

  override create(object: SoftwareArtifact): Observable<SoftwareArtifact> {
    return this.http
      .post<
        SoftwareArtifact[] | SoftwareArtifact
      >(this.baseUrl + this.apiEndpoint, [object], { headers: this.getHeades() })
      .pipe(
        map((response) => {
          const artifact = Array.isArray(response) ? response[0] : response;
          if (!artifact) {
            throw new Error(
              'Failed to create software artifact: empty response.',
            );
          }
          return artifact;
        }),
        map((artifact) => this.loadedDataTransform(artifact)),
      );
  }
}
